import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-counter',
  templateUrl: './counter.component.html',
  styleUrls: ['./counter.component.scss'],
  imports: [CommonModule],
})
export class CounterComponent {
  @Input()
  count: string | number | undefined | null = '23';

  @Input()
  size: 'small' | 'large' = 'small';
}
